import { render } from "./AdminRiderTracking.vue?vue&type=template&id=089e5299&ts=true&lang=true"
import script from "./AdminRiderTracking.vue?vue&type=script&lang=ts"
export * from "./AdminRiderTracking.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__